/*
* Send bids dash for authenticated users
*/

import './dashboard.css';
import '@progress/kendo-ui';

import { Grid } from '@progress/kendo-grid-react-wrapper';
import * as JSZip from 'jszip';
import * as _ from 'lodash';
import moment from 'moment';
import * as React from 'react';
import { Row, Button, ButtonToolbar, DropdownButton, MenuItem, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import VirtualizedSelect from 'react-virtualized-select';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import * as KendoWrappers from '../common/kendoforms/componentwrappers';
import * as Actions from '../actions';
import * as MutateActions from '../actions/mutate';
import * as AppComp from '../common/app-component-base';
import * as AppUtilities from '../common/apputilities';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import { FormUtilities } from '../common/formutilities';
import { GridUtilities } from '../common/grid/gridutilities';
import { NavigationLinks } from '../common/navigation';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';
import ApiEndpoints from '../config/apiendpoints';
import * as DetailFormCommon from '../inventory/detail-form/common';
import * as ReduxQueries from '../queries';
import { userHasRole } from 'src/utils/userUtils';

(window as any).JSZip = JSZip;

export interface ISendBidsSearchProps extends AppComp.IAppComponentProps {
    filterByRegions: any;
    filterByStatuses: any;
    filterByUsers: any;
    navigateTo?: any;
    sendBidsFilterManager?: any;
    sendBidsFilterStatusId?: any;
    sendBidsFilterRegionId?: any;
    setBidsSent?: any;
    forceRequest?: any;
}

export interface ISendBidsSearchState extends AppComp.IAppComponentState {
    selectedKeys?: any;
    formChanges?: any;
    bulkBidsOperation: string;
    bulkBidsValue: any;
    showModalBulkBids: boolean;
    showModalSetBidsSent?: boolean;
}

class SendBidsSearch extends AppComp.AppComponent<ISendBidsSearchProps, ISendBidsSearchState> {
    public MomentNow: any = moment();
    public isGridExporting: boolean = false;
    public kendoGridWidgetRef: any;

    public gridOptions = GridUtilities.kendoGridOptionsPaging(
        [
            GridUtilities.kendoGridColumnDefinition('', '', 30, 100, undefined, { selectable: true }),
            GridUtilities.kendoGridColumnDefinition('associationId', this.appTextGridColumnHeader('association-id'), 50, 10),
            GridUtilities.kendoGridColumnDefinition('associationName', this.appTextGridColumnHeader('association-name'), 210, 20,
                                                    GridUtilities.kendoGridLinkColumnTemplate('associationName', 'associationDetailLinkHref', this.appText('association-detail-link-title')),
                                                    {
                                                        aggregates: ['count'],
                                                        footerTemplate: `#=count# ${this.appTextResults()}`,
                                                    }),
            GridUtilities.kendoGridColumnDefinitionHidden('associationLocationMapAddress1', 1003),
            GridUtilities.kendoGridColumnDefinitionHidden('associationLocationMapCity', 1004),
            GridUtilities.kendoGridColumnDefinitionHidden('associationLocationMapState', 1005),
            GridUtilities.kendoGridColumnDefinitionHidden('associationLocationMapZip', 1006),
            GridUtilities.kendoGridColumnDefinition('associationLocation', this.appTextGridColumnHeader('location'), 110, 30),
            GridUtilities.kendoGridColumnDefinition('clientName', this.appTextGridColumnHeader('client-name'), 210, 40,
                                                    GridUtilities.kendoGridLinkColumnTemplate('clientName', 'clientDetailLinkHref', this.appText('client-detail-link-title')),
                                                    ),
            GridUtilities.kendoGridColumnDefinition('statusName', this.appTextGridColumnHeader('status'), 130, 50, ''),
            GridUtilities.kendoGridColumnDefinition('managerUser', this.appTextGridColumnHeader('manager'), 60, 60),
            GridUtilities.kendoGridColumnDefinition('bidDateValue', this.appTextGridColumnHeader('bid-date'), 70, 80, undefined, { format: '{0:d}' }),
            GridUtilities.kendoGridColumnDefinition('viewOrderLink', '', 80, 90,
                                                    GridUtilities.kendoGridLinkColumnTemplate('viewOrderLink', 'viewOrderLinkHref', this.appText('view-bid-link-title')),
                                                    { headerTemplate: '' }),
            GridUtilities.kendoGridColumnDefinition('viewInventoryLink', '', 90, 100,
                                                    GridUtilities.kendoGridLinkColumnTemplate('viewInventoryLink', 'viewInventoryLinkHref', this.appText('view-inventory-link-title')),
                                                    { headerTemplate: '' }),
        ],
        this.appText('no-results'),
        {
            excelExport: this.onGridExcelExport,
            persistSelection: true,
            widgetRef: (w) => { this.kendoGridWidgetRef = w; },
            change: (e) => {
                const selectedKeys = e.sender.selectedKeyNames();
                this.handleGridRowCheckbox(selectedKeys);
            },
        },
        this.appTextPageTitle()
    );

    public constructor(props: ISendBidsSearchProps) {
        super(props, 'app.send-bids.');

        this.state = {
            selectedKeys: [],
            showModalBulkBids: false,
            bulkBidsOperation: '',
            bulkBidsValue: '',
            showModalSetBidsSent: false,
            formChanges: {},
        };
    }

    public componentDidMount() {
        const enforce = this.enforceAdminOrEmployeeOnly();

        if (enforce) { this.props.navigateTo(NavigationLinks.clientDashboardHome()); }
    }

    public onGridExcelExport(e: any) {
        if (!this.isGridExporting) {
            e.sender.showColumn(2);
            e.sender.showColumn(3);
            e.sender.showColumn(4);
            e.sender.showColumn(5);

            e.preventDefault();

            this.isGridExporting = true;

            e.sender.saveAsExcel();
        } else {
            e.sender.hideColumn(2);
            e.sender.hideColumn(3);
            e.sender.hideColumn(4);
            e.sender.hideColumn(5);

            this.isGridExporting = false;
        }
    }

    public extendGridData(records: Array<any>) {
        // Extend grid row data
        if (!records) { return []; }

        return records.map( r => {
            let record = _.cloneDeep(r);

            // Association name
            record.associationName = Formatters.getStr(record, 'association.name');

            // Association name link details
            record.associationDetailLinkHref = (Formatters.getInt(record, 'associationId')) ? NavigationLinks.associationDetail(Formatters.getInt(record, 'associationId')) : '';

            // Association Location
            record.associationLocation = (record.association && record.association.location) ? Formatters.composeLocationCityState(record.association.location) : '';

            // Association Location Details for Map Export
            record.associationLocationMapAddress1 = Formatters.getStr(record, 'association.location.address1');
            record.associationLocationMapCity = Formatters.getStr(record, 'association.location.city');
            record.associationLocationMapState = Formatters.getStr(record, 'association.location.stateCode');
            record.associationLocationMapZip = Formatters.getStr(record, 'association.location.postalCode');

            // Client name
            record.clientName = Formatters.getStr(record, 'client.name');

            // Client name link details
            record.clientDetailLinkHref = (Formatters.getInt(record, 'clientId')) ? NavigationLinks.clientDetail(Formatters.getInt(record, 'clientId')) : '';

            // Service level name
            record.serviceLevelName = Formatters.getStr(record, 'serviceLevel.name');

            // Status name
            record.statusName = Formatters.getStr(record, 'status.name');

            // Manager
            record.managerUser = Formatters.getStr(record, 'user.username');

            // Coordinator
            record.coordinatorUser = Formatters.getStr(record, 'siteInspector.username');

            // Bid date
            record.bidDateValue = record.bidDate ? new Date(record.bidDate) : '';

            // Start date
            record.startDateValue = record.startDate ? new Date(record.startDate) : '';

            // Due date
            record.dueDateValue = record.dueDate ? new Date(record.dueDate) : '';

            // Calculate number of days & weeks until due
            record.numDays = record.dueDateValue ? moment(record.dueDateValue).diff(this.MomentNow, 'days') : '';
            record.numDaysSort = AppUtilities.isNumeric(record.numDays) ? Number(parseInt(record.numDays, 10)) : -99999;
            record.numWeeks = record.dueDateValue ? moment(record.dueDateValue).diff(this.MomentNow, 'weeks') : -1;

            // View order link
            record.viewOrderLink = '';
            record.viewOrderLinkHref = '';
            if (Formatters.getInt(record, 'orderId')) {
                record.viewOrderLink = this.appText('view-bid');
                record.viewOrderLinkHref = NavigationLinks.orderDetail(Formatters.getInt(record, 'orderId'));
            }

            // View inventory link
            record.viewInventoryLink = '';
            record.viewInventoryLinkHref = '';
            if (record.association && Formatters.getInt(record, 'associationId')) {
                record.viewInventoryLink = this.appText('view-inventory');
                record.viewInventoryLinkHref = NavigationLinks.associationInventory(Formatters.getInt(record, 'associationId'));
            }

            return record;
        });
    }

    // Handlers
    public handleGridRowCheckbox(keys: any) {
        const nextSelectedKeys = _.cloneDeep(keys);
        const prevSelectedKeys = _.get(this.state, 'selectedKeys', []);
        const same = _.isEqual(nextSelectedKeys, prevSelectedKeys);

        if (!same) { this.setState({ selectedKeys: nextSelectedKeys }); }
    }

    public handleSelectManager(e: any) {
        const value = e ? e.value : '';
        this.props.sendBidsFilterManager(value);
    }

    public handleSelectStatusId(e: any) {
        const value = e ? e.value : 0;
        this.props.sendBidsFilterStatusId(value);
    }

    public handleSelectRegionId(e: any) {
        const value = e ? e.value : 0;
        this.props.sendBidsFilterRegionId(value);
    }

    public handlePrintSelectedEnvelopesButton(e: any) {
        const selectedOrders = _.get(this.state, 'selectedKeys', []);
        const navLink = NavigationLinks.orderBidEnvelopeMultiplePdf(selectedOrders);

        window.open(navLink, 'print-bid-envelope-multiple', 'menubar=0,toolbar=0,location=0,personalbar=0,status=0');
    }

    public handlePrintSelectedBidsButton(e: any) {
        const selectedOrders = _.get(this.state, 'selectedKeys', []);
        const navLink = NavigationLinks.orderBidLetterMultiplePdf(selectedOrders);

        window.open(navLink, 'print-bid-letter-multiple', 'menubar=0,toolbar=0,location=0,personalbar=0,status=0');
    }

    public handleShowModalSetBidsSent(e: any) {
        // Set multiple bid statuses to 'bid sent', also set 'bid sent date' field

        this.setState({ showModalSetBidsSent: true });
    }

    public handleCloseModalSetBidsSent() {
        this.setState({ showModalSetBidsSent: false });
    }

    public handleSetBidsSentModalButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const selectedOrders = _.get(this.state, 'selectedKeys', []);

        const changeData = {
            bidObjIds: selectedOrders
        };

        this.props.setBidsSent(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                // this.originalOrderModalFormDataCache = {};

                if (this.kendoGridWidgetRef) { this.kendoGridWidgetRef.clearSelection(); }
                this.setState({ showModalSetBidsSent: false });

                this.props.forceRequest();
            } else {
              // Error during creation...
            }
        });
    }

    public handleFormInputChange(e: any, x: any) {
        // console.log('handleForminputchange', {e: e, x: x });

        // const getChangesResult = this.getFormChanges(e, x);
        // // console.log('handleForminputchange getChangesResult', {getChangesResult: getChangesResult, e: e, x: x });
        // if (getChangesResult.applyChanges) {
        //     this.setState({
        //         formChanges: getChangesResult.formChanges
        //     });
        // }
    }

    public handleBidSentDateChange(e: any, obj: any) {
        // console.log(`handleBidSentDateChange`, { e });
    }

    // Renderers
    public renderSetBidsSentModal = (formData: any) => {
        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 };

        const inputProps = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            handleChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        let inputPropsFullWidth = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            handleChange: (n, v) => { this.handleFormInputChange(n, v); },
            className: 'inventory-detail-input-full-width',
        });

        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
        });

        let inputPropsSmallDate = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleBidSentDateChange(n, v); },
            colInputXs: 12,
            className: '',
            // format: 'M/dd/yyyy',
            // format: 'YYYY',
            formatPlaceholder: 'formatPattern',
        });

        return (
            <Modal show={this.state.showModalSetBidsSent} enforceFocus={false} onHide={() => this.handleCloseModalSetBidsSent()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.appText('modals.set-bids-sent.title')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <p className="calculate-prices-modal-content">Are you sure you want to set the selected bids as sent? The status will be updated to "Bid Sent" and the "Bid Sent Date" field will be set to today's date.</p>
                        {/*
                        <DetailFormCommon.InventoryDetailFormSection title="">
                            <KendoWrappers.KendoDateInputOptional
                                name="bidSentDate"
                                clearable={false}
                                required={true}
                                disabled={false}
                                label={this.appText('modals.set-bids-sent.bid-sent-date')}
                                labelHelpTooltip=""
                                value={_.get(formData, 'bidSentDate')}
                                onChange={(n, v) => { this.handleBidSentDateChange(n, v); }}
                                {...inputPropsSmallDate}
                            />
                            <DetailFormCommon.InventoryDetailFormSectionSpacing />
                        </DetailFormCommon.InventoryDetailFormSection> */ }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" onClick={(e) => this.handleSetBidsSentModalButton(e)}>{this.appText('modals.set-bids-sent.set-bids-sent')}</Button>
                    <Button bsStyle="danger" onClick={() => this.handleCloseModalSetBidsSent()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public render() {
        const { search, filterByUsers, filterByRegions, filterByStatuses, ...rest } = this.props;

        const rows = this.extendGridData(search.results);
        const dataSource = GridUtilities.kendoGridDataSourcePaged(rows, {
            aggregate: [
                { field: 'associationName', aggregate: 'count' },
                { field: 'acceptedPrice', aggregate: 'sum' }
            ],
            sort: {
                dir: 'asc',
                field: 'numDaysSort',
            },
            schema: {
                model: {
                    id: '_id',
                }
            }
        });

        // Prepare select dropdown options
        let extendedUsers = [];
        if (AppUtilities.isArrayWithLength(filterByUsers)) {
            extendedUsers = filterByUsers.map(c => {
                c.sort = Formatters.getStr(c, 'contact.firstName').trim().toLowerCase();
                if (!c.label) { c.label = Formatters.composeUsernameLabel(c, true); }

                return c;
            });
        }
        const filterOptionAny = this.appTextFilterOptionAny();
        const users = FormUtilities.getExtendedFilterOptions(_.filter(extendedUsers, ((u) => userHasRole(u, 'administrator'))), 'username', 'sort', filterOptionAny, '', '_');
        const regions = FormUtilities.getExtendedFilterOptions(filterByRegions, 'regionId', 'label', filterOptionAny, -1);
        const statuses = FormUtilities.getExtendedFilterOptions(filterByStatuses, 'statusId', 'statusId', this.appText('filter-option-status-send-bids'), -1);

        const isAdmin = (this.enforceAdminOnly()) ? false : true;
        const dropDisabled = false;

        // Grid buttons
        let gridHeaderBulkActionButtonsDisabled = (_.size(_.get(this.state, 'selectedKeys', [])) > 0) ? false : true;
        let gridHeaderBulkActionButtonsProps = {
            bsSize: 'xs',
            bsStyle: 'info',
        };
        let gridHeaderBulkActionButtons = (
            <div className="send-bids-grid-toolbar-wrapper">
                <Row>
                    <Col xs={12}>
                        <ButtonToolbar className="association-inventory-components-grid-toolbar">
                            <Button
                                {...gridHeaderBulkActionButtonsProps}
                                disabled={gridHeaderBulkActionButtonsDisabled}
                                onClick={(e) => this.handlePrintSelectedEnvelopesButton(e)}
                            >
                                <i className="fa fa-envelope" /> {this.appText('links.print-selected-envelopes')}
                            </Button>

                            <Button
                                {...gridHeaderBulkActionButtonsProps}
                                disabled={gridHeaderBulkActionButtonsDisabled}
                                onClick={(e) => this.handlePrintSelectedBidsButton(e)}
                            >
                                <i className="fa fa-file" /> {this.appText('links.print-selected-bids')}
                            </Button>

                            <Button
                                {...gridHeaderBulkActionButtonsProps}
                                disabled={gridHeaderBulkActionButtonsDisabled}
                                onClick={(e) => this.handleShowModalSetBidsSent(e)}
                            >
                                <i className="fa fa-paper-plane" /> {this.appText('links.set-selected-to-sent')}
                            </Button>

                        </ButtonToolbar>
                    </Col>
                </Row>
            </div>
        );

        const formData = {
            bidSentDate: new Date()
        };

        const pageTitle = this.appTextResultsAndPageTitle(rows.length, this.commonMessagePaths.searchResults, false, 'list-of-send-bids', true);
        const page = (
            <WhiteBoxPageSection title={pageTitle}>
                {this.renderSetBidsSentModal(formData)}
                <Row>
                    <Col xs={12}>
                        <form onSubmit={e => { e.preventDefault(); }}>
                            <Row className="form-group">

                                <Col xs={2} md={4} xl={2}>
                                    <label className="control-label">{this.appText('filter-by-manager')}</label>
                                    <VirtualizedSelect
                                        clearable={false}
                                        filterOptions={users.filter}
                                        name="manager-filter"
                                        onChange={e => this.handleSelectManager(e)}
                                        options={users.options}
                                        value={search.filters.manager}
                                        disabled={dropDisabled}
                                    />
                                </Col>
                            </Row>

                            <Row className="form-group">
                                <Col xs={2} md={4} xl={2}>
                                    <label className="control-label">{this.appText('filter-by-status-id')}</label>
                                    <VirtualizedSelect
                                        clearable={false}
                                        filterOptions={statuses.filter}
                                        name="status-filter"
                                        onChange={e => this.handleSelectStatusId(e)}
                                        options={statuses.options}
                                        value={search.filters.statusId}
                                    />
                                </Col>

                                <Col xs={2} md={4} xl={2}>
                                    <label className="control-label">{this.appText('filter-by-region-id')}</label>
                                    <VirtualizedSelect
                                        clearable={false}
                                        filterOptions={regions.filter}
                                        name="region-filter"
                                        onChange={e => this.handleSelectRegionId(e)}
                                        options={regions.options}
                                        value={search.filters.regionId}
                                    />
                                </Col>
                            </Row>
                        </form>
                    </Col>
                </Row>

                {gridHeaderBulkActionButtons}

                <Row>
                    <Col xs={12}>
                        <div className="home-dashboard-table-wrapper">
                            <Grid dataSource={dataSource} {...this.gridOptions} />
                        </div>
                    </Col>
                </Row>
            </WhiteBoxPageSection>
        );

        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={pageTitle} {...rest}>
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrl = () => ApiEndpoints.getPreparedBidsSearchUrl();

const mapPropsToConfigs = (props) => ReduxQueries.Queries.searchSendBidsRequest(
    getApiUrl(),
    ReduxQueries.PropsAccessToken(props),
    _.get(props, 'search.filters.manager', ''),
    _.get(props, 'search.filters.regionId', -1),
    _.get(props, 'search.filters.statusId', -1),
);

const mapStateToProps = (state, props) => {
    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(), state, props, {
        filterByRegions: state.entities.searchSendBidsRegions,
        filterByStatuses: state.entities.searchSendBidsStatuses,
        filterByUsers: state.entities.searchSendBidsUsers,
        search: {
            results: state.entities.searchSendBidsResults,
            filters: {
                manager: state.searchFiltersSendBids.manager,
                regionId: state.searchFiltersSendBids.regionId,
                statusId: state.searchFiltersSendBids.statusId,
            }
        },
    });
};

const mapDispatchToProps = dispatch => ({
    dispatch: (d) => dispatch(d),
    navigateTo: (path) => dispatch(push(path)),
    // preparedBidsFilterManager: (v) => dispatch(Actions.preparedBidsFilterManager(v)),
    // preparedBidsFilterCoordinator: (v) => dispatch(Actions.preparedBidsFilterCoordinator(v)),
    // preparedBidsFilterStatusId: (v) => dispatch(Actions.preparedBidsFilterStatusId(v)),
    // preparedBidsFilterRegionId: (v) => dispatch(Actions.preparedBidsFilterRegionId(v)),
    sendBidsFilterManager: (v) => dispatch(Actions.sendBidsFilterManager(v)),
    sendBidsFilterStatusId: (v) => dispatch(Actions.sendBidsFilterStatusId(v)),
    sendBidsFilterRegionId: (v) => dispatch(Actions.sendBidsFilterRegionId(v)),
    setBidsSent: (d: any, a: string, o: boolean) => dispatch(MutateActions.setBidsSentMutateAsync(d, a, o)),
});

const SendBidsSearchContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
  )(SendBidsSearch);

export default withRouter(SendBidsSearchContainer);



// WEBPACK FOOTER //
// ./src/dashboard/send-bids.tsx